var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYouxiang2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7V3.5a.5.5 0 00-.5-.5H2.25a.5.5 0 00-.5.5v9c0 .276.223.5.499.5H7.5",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3l5.556 3.704a.8.8 0 00.888 0L14 3",
    stroke: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 11.5,
    r: 2.5,
    stroke: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.996 13.29a.5.5 0 10-.707.706l.707-.707zm.07 1.484a.5.5 0 10.708-.707l-.707.707zm-.777-.778l.778.778.707-.707-.778-.778-.707.707z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_youxiang2.7f86106c.svg";
export { SvgTongyongYouxiang2 as ReactComponent };